<template>
  <div>
    <v-data-table
      :headers="dataTableHeaders"
      :items="cartItems"
      hide-default-footer
      :items-per-page="100"
      class="elevation-1"
    >
      <!-- アクション -->
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="showUpdateDialog(item)"> mdi-pencil </v-icon>
        <v-icon small @click="showDeleteDialog(item)"> mdi-delete </v-icon>
      </template>
      <!-- サムネイル -->
      <template v-slot:item.thumbnail="{ item }">
        <v-layout justify-center>
          <v-img
            :src="`${item.product.thumbnailUrl}`"
            height="3vw"
            min-height="75px"
            width="4vw"
            min-width="120px"
            class="my-2 pa-0"
          ></v-img>
        </v-layout>
      </template>
      <!-- 商品番号 -->
      <template v-slot:item.productName="{ item }">
        <p class="text-caption text-center">
          {{ item.product.nameJa }}<br />{{ item.product.productNo }}
        </p>
      </template>
      <!-- カラー -->
      <template v-slot:item.colorSize="{ item }">
        <p class="text-caption text-center">
          {{ item.product.colorJa }}<br />{{ item.product.sizeJa }}
        </p>
      </template>
      <!-- 単価 -->
      <template v-slot:item.sellingPrice="{ item }">
        <p class="text-caption text-right">{{ item.product.sellingPriceJpy }}</p>
      </template>
      <!-- 数量 -->
      <template v-slot:item.quantity="{ item }">
        <p class="text-caption text-center">{{ item.quantity }}</p>
      </template>
      <!-- 小計 -->
      <template v-slot:item.subTotalJpy="{ item }">
        <p class="text-caption text-right">{{ item.subTotalJpy }}</p>
      </template>
      <!-- 発送手数料 -->
      <template slot="body.append">
        <tr>
          <td :colspan="dataTableHeaders.length - 1" class="text-caption text-right">
            発送手数料（税込）
          </td>
          <td colspan="1" class="text-caption text-right">{{ carrigeWithTaxJpy }}</td>
        </tr>
      </template>
      <!--合計-->
      <template slot="body.append">
        <tr>
          <td
            :colspan="dataTableHeaders.length - 1"
            class="text-caption font-weight-bold text-right"
          >
            合計金額（税込）
          </td>
          <td colspan="1" class="text-caption font-weight-bold text-right">
            {{ totalPriceWithTaxJpy }}
          </td>
        </tr>
      </template>
    </v-data-table>
    <div v-show="this.isShowActionButton" class="mx-2 my-5">
      <ul>
        <li class="text-caption">
          合計金額が ¥33,000（税込）以上の場合は、発送手数料はかかりません。
        </li>
        <li class="text-caption">
          「各種オンライン申請のみ」のご注文の場合は、合計金額にかかわらず発送手数料はかかりません。
        </li>
        <li class="text-caption">1回の注文につき購入可能な金額は100万円（税込）未満です。</li>
      </ul>
    </div>
    <!-- 削除確認ダイアログ（ここから） -->
    <v-dialog v-model="isShowDeleteDialog" persistent max-width="350px">
      <v-card>
        <v-card-title class="ma-5 justify-center text-subtitle-2">
          商品を削除してもよろしいですか？
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn large color="gray darken-1" text @click="closeDeleteDialog">いいえ</v-btn>
          <v-btn large color="blue darken-1" text @click="deleteCartItem">はい</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 削除確認ダイアログ（ここまで） -->
    <!-- 更新ダイアログ（ここから） -->
    <v-dialog v-model="isShowUpdateDialog" persistent max-width="250px">
      <v-card>
        <v-card-title class="ma-5 justify-center text-subtitle-2"> カート商品の更新 </v-card-title>
        <v-card-subtitle class="ma-5soud text-center">
          <div class="d-flex flex-row align-baseline" width="80%">
            <v-text-field
              type="number"
              id="quantity"
              name="quantity"
              v-model="editedCartItem.quantity"
              label="数量"
              required
              max="999"
              min="1"
              class="mx-10 pa-0"
            ></v-text-field>
          </div>
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="closeUpdateDialog" class="mx-2"> キャンセル </v-btn>
          <v-btn color="primary" depressed @click="updateCartItem" class="mx-2">更新 </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 更新ダイアログ（ここまで） -->
  </div>
</template>

<script>
export default {
  computed: {
    /**
     * 発送手数料を取得する
     */
    carrigeWithTaxJpy: {
      cache: false,
      get() {
        return this.$store.getters['shoppingOrder/carriageJpy'];
      },
    },
    /**
     * カート商品を取得する
     */
    cartItems: {
      cache: false,
      get() {
        return this.$store.getters['shoppingOrder/cartItems'];
      },
    },
    /**
     * テーブルヘッダーを取得する
     */
    dataTableHeaders: function () {
      const headers = [
        { text: '更新/削除', value: 'actions', sortable: false, align: 'center', width: '90px' },
        { text: '商品画像', value: 'thumbnail', sortable: false, align: 'center', width: '100px' },
        { text: '商品名/商品番号', value: 'productName', sortable: false, align: 'center' },
        { text: 'カラー/サイズ', value: 'colorSize', sortable: false, align: 'center' },
        { text: '単価', value: 'sellingPrice', sortable: false, align: 'center' },
        { text: '数量', value: 'quantity', sortable: false, align: 'center' },
        { text: '小計', value: 'subTotalJpy', sortable: false, align: 'center' },
      ];

      // アクションボタン不要の場合、ヘッダー項目を削る
      if (!this.isShowActionButton) {
        headers.some(function (header, i) {
          if (header.value === 'actions') headers.splice(i, 1);
        });
      }

      return headers;
    },
    /**
     * 合計額を取得する
     */
    totalPriceWithTaxJpy: {
      cache: false,
      get() {
        return this.$store.getters['shoppingOrder/totalPriceWithTaxJpy'];
      },
    },
  },
  created() {
    this.isShowActionButton = this.isInitialShowActionButton;
  },
  data() {
    return {
      isShowActionButton: true,
      isShowDeleteDialog: false,
      isShowUpdateDialog: false,
      editedCartItem: {
        productId: -1,
        quantity: 0,
      },
      defaultCartItem: {
        productId: -1,
        quantity: 0,
      },
    };
  },
  methods: {
    /**
     * 削除確認ダイアログを閉じる
     */
    closeDeleteDialog: function () {
      this.isShowDeleteDialog = false;
      this.editedCartItem = Object.assign({}, this.defaultCartItem);
      // カートに商品がない場合は商品選択画面に戻る
      if (!this.cartItems || this.cartItems.length < 1) this.$router.push('/');
    },
    /**
     * 更新ダイアログを閉じる
     */
    closeUpdateDialog: function () {
      this.isShowUpdateDialog = false;
      this.editedCartItem = Object.assign({}, this.defaultCartItem);
      // カートに商品がない場合は商品選択画面に戻る
      if (!this.cartItems || this.cartItems.length < 1) this.$router.push('/');
    },
    /**
     * カート商品を削除する
     */
    deleteCartItem: function () {
      this.$store.commit('shoppingOrder/deleteCartItem', {
        productId: this.editedCartItem.productId,
      });
      this.closeDeleteDialog();
    },
    /**
     * 削除確認ダイアログを表示する
     */
    showDeleteDialog: function (cartItem) {
      this.isShowDeleteDialog = true;
      this.editedCartItem.productId = cartItem.productId;
    },
    /**
     * 更新ダイアログを表示する
     */
    showUpdateDialog: function (cartItem) {
      this.isShowUpdateDialog = true;
      this.editedCartItem.productId = cartItem.productId;
      this.editedCartItem.quantity = cartItem.quantity;
    },
    /**
     * カート商品を更新する
     */
    updateCartItem: function () {
      const quantity = parseInt(this.editedCartItem.quantity);
      if (isNaN(quantity)) return;
      if (quantity < 1) {
        this.$store.commit('shoppingOrder/deleteCartItem', {
          productId: this.editedCartItem.productId,
        });
      } else {
        this.$store.commit('shoppingOrder/updateQuantity', {
          productId: this.editedCartItem.productId,
          quantity: this.editedCartItem.quantity,
        });
      }
      this.closeUpdateDialog();
    },
  },
  props: {
    isInitialShowActionButton: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'stylesheets/debug.scss';
</style>
